import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Full-size frame image popup, extracted unchanged from frame-assets-manager (KAN-149 AC-6) so Photobooth Management,
 * Artist Management and the artist statements share one popup. Anything projected inside appears as a side panel
 * (frame-assets-manager projects its Frame Settings panel; other screens show the image only).
 */
@Component({
  selector: 'app-frame-image-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './frame-image-preview.component.html',
  styleUrls: ['./frame-image-preview.component.css']
})
export class FrameImagePreviewComponent {
  @Input() url: string | null = null;
  @Input() alt = 'Full Size Preview';
  @Input() hasPanel = false;
  @Output() closed = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape() {
    if (this.url) this.closed.emit();
  }
}
